import { render } from "./Home.vue?vue&type=template&id=adb7f634&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=adb7f634&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adb7f634"]])

export default __exports__